import React, {Component} from 'react';
import './App.css';
import {BrowserRouter, Route} from 'react-router-dom';
//import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import Home from './components/Home';
import Contribute from './components/pages/Contribute';

import Bidayuh from './components/pages/Bidayuh';
import BidayuhArtefacts from './components/pages/Bidayuh/Artefacts';
import BidayuhCeremonies from './components/pages/Bidayuh/Ceremonies';
import BidayuhCostumes from './components/pages/Bidayuh/Costume';
import BidayuhFolklores from './components/pages/Bidayuh/Folklore';

import Iban from './components/pages/Iban';
import IbanArtefacts from './components/pages/Iban/Artefacts';
import IbanCostumes from './components/pages/Iban/Costume';
import IbanCeremonies from './components/pages/Iban/Ceremonies';
import IbanFolklores from './components/pages/Iban/Folklore';

import Ulu from './components/pages/Ulu';
import UluArtefacts from './components/pages/OrangUlu/Artefacts';
import UluCostumes from './components/pages/OrangUlu/Costume';
import UluCeremonies from './components/pages/OrangUlu/Ceremonies';
import UluFolklores from './components/pages/OrangUlu/Folklore';

import Melanau from './components/pages/Melanau';
import MelanauArtefact from './components/pages/Melanau/Artefacts';
import MelanauCostumes from './components/pages/Melanau/Costume';
import MelanauCeremonies from './components/pages/Melanau/Ceremonies';
import MelanauFolklores from './components/pages/Melanau/Folklore';

import Melayu from './components/pages/Melayu';
import MelayuArtefacts from './components/pages/Melayu/Artefacts';
import MelayuCostumes from './components/pages/Melayu/Costume';
import MelayuCeremonies from './components/pages/Melayu/Ceremonies';
import MelayuFolklores from './components/pages/Melayu/Folklore';
import Navbar from './components/Navbar';


class App extends Component {
  constructor(){ 
    super();
    this.state = { 
      keywords:[],
      searchField: '',
    }
  }
  render (){

  return (
 
    <BrowserRouter>
      <Navbar/> 
  
        <Route path="/" exact component = {Home} />

        <Route path="/contribute" component={Contribute}/> 
                  
        <Route path='/bidayuh' component = {Bidayuh} />
        <Route path='/iban' component = {Iban} />
        <Route path ='/ulu' component ={Ulu} />
        <Route path ='/melanau' component={Melanau}/>
        <Route path='/malay' component={Melayu} />

        <Route path = '/bidayuh-artefacts' render = {() => <BidayuhArtefacts/>} />
        <Route path='/bidayuh-ceremonies' render = {() => <BidayuhCeremonies/>} />
        <Route path = '/bidayuh-costumes' render = {() => <BidayuhCostumes/> }/>
        <Route path = '/bidayuh-folklores' render = {() => <BidayuhFolklores/>} />

        <Route path ='/iban-artefacts' render = {() => <IbanArtefacts/>} /> 
        <Route path='/iban-costumes' render = {() => <IbanCostumes/>} />
        <Route path='/iban-ceremonies' render = {() => <IbanCeremonies/> } /> 
        <Route path='/iban-folklores' render = {() => <IbanFolklores/>} /> 

        <Route path ='/ulu-artefacts' render = {() => <UluArtefacts/>} />
        <Route path='/ulu-costumes' render = {() => <UluCostumes/> } /> 
        <Route path='/ulu-ceremonies' render = {() => <UluCeremonies/>} /> 
        <Route path ='/ulu-folklores' render = {() => <UluFolklores/> } />

        <Route path ='/melanau-artefacts' render = {() => <MelanauArtefact/>} />
        <Route path ='/melanau-costumes' render = {() => <MelanauCostumes/> } /> 
        <Route path='/melanau-ceremonies' render = {() => <MelanauCeremonies/> } /> 
        <Route path = '/melanau-folklores' render = {() => <MelanauFolklores/>} /> 

        <Route path='/malay-artefacts' render = {() => <MelayuArtefacts/>} /> 
        <Route path = '/malay-costumes' render = {() => <MelayuCostumes/> } /> 
        <Route path ='/malay-ceremonies' render = {() => <MelayuCeremonies/> } /> 
        <Route path = '/malay-folklores' render = {() => <MelayuFolklores/> } /> 


    </BrowserRouter>
 
  );
        }
      
}

export default App;
